<template>
  <section class="userManagedServices">
    <v-container
      mt-3
      fluid
      class="header">
      <v-layout row >
        <v-flex
          xs12
          sm5
          md4>
          <v-card>
            <div class="opportunity-lookup">
              <h4>Look up Opportunity Registration</h4>
              <v-form @submit.prevent="onSearchOpportunityId">
                <v-text-field
                  v-model.trim="searchId"
                  :success="!newManagedServices.searchError"
                  :error="newManagedServices.searchError"
                  :messages="newManagedServices.searchMessage"
                  :loading="newManagedServices.searching"
                  label="Enter Opportunity ID"
                  solo
                  outlined
                  append-icon="search"
                  dark
                  @click:append="onSearchOpportunityId"
                />
              </v-form>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <formUserManagedServicesList />
    <div
      v-if="(managedServicesList.selectedWorkload.length > 0 ? true: false )"
      class="request-details">
      <v-container
        fluid
        style="padding: 0">
        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm12
            md12
            xl12>
            <section>
              <v-container
                fluid
                class="section-header">
                <div class="section-header-title" >
                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <h4>Customer Owned Accounts - Request Managed Svcs</h4>
                    </v-flex>
                  </v-layout>
                </div>
              </v-container>
            </section>
            <v-container
              v-if="(currentPage === 'page1')"
              class="request-details-p1">
              <v-layout row align-center class="form-row p1">
                <v-flex
                  md6
                  pt-2
                  class="d-flex align-center">
                  <label>Describe any customization per the SOW that deviates from the standard Gold Managed Services.</label>
                </v-flex>
                <v-flex
                  md6>
                  <v-textarea
                    v-model="newManagedServices.Description"
                    placeholder=""
                    name="description"
                    solo
                  />
                </v-flex>
              </v-layout>
              <v-layout row align-center class="form-row">
                <v-flex
                  md12
                  pt-2
                  class="d-flex align-center">
                  <label>List the Client owned AWS Account ID numbers to which the Gold Managed Services need to be deployed. </label>
                </v-flex>
              </v-layout>
              <v-layout row align-center class="form-row">
                <v-flex
                  md6
                  pt-2
                  pr-4
                  class="align-center">
                  <label>Client owned AWS Account ID</label>
                  <v-text-field
                    v-model="newManagedServices.AWS_Accounts"
                    label=""
                    placeholder=""
                    solo
                  />
                </v-flex>
                <v-flex
                  md6
                  pt-2
                  class="align-center">
                  <label>Region(s)</label>
                  <v-autocomplete
                    v-model.lazy="newManagedServices.AWS_Regions"
                    :items="regions"
                    item-text="label"
                    item-value="value"
                    persistent-hint
                    open-on-clear
                    attach
                    multiple
                    chips
                    small-chips
                    solo
                  />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm12 md12 xl12>
                  <v-layout align-top justify-end style="margin-top:-25px">
                    <v-btn class="opp-btn" color="warning" @click="add">Add Account ID</v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm12 md12 xl12>
                  <div style="background:#F1F0F0;padding:10px;margin-bottom:15px;font-size:13px">
                    <v-dialog v-model="dialog" max-width="500px">
                      <v-card>
                        <v-card-text>
                          <v-container grid-list-md>
                            <v-layout wrap>
                              <v-flex xs12 sm12 md12 xl12>
                                <label>Client owned AWS Account ID</label>
                                <v-text-field
                                  v-model="editedItem.aws_account_id"
                                  label="AWS Accounts"
                                  placeholder="AWS Accounts"
                                  solo
                                />
                              </v-flex>
                              <v-flex xs12 sm12 md12 xl12>
                                <label>Region(s)</label>
                                <v-autocomplete
                                  v-model.lazy="editedItem.regions"
                                  :items="regions"
                                  item-text="label"
                                  item-value="value"
                                  persistent-hint
                                  open-on-clear
                                  attach
                                  multiple
                                  chips
                                  small-chips
                                  solo
                                />
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn @click="close">Cancel</v-btn>
                          <v-btn class="opp-btn" color="warning" @click="save">Save</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-data-table
                      :headers="headers"
                      :items="currentList"
                      :items-per-page="2"
                      class="elevation-1"
                    >
                      <template v-slot:items="props">
                        <td class="">
                          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                          <v-icon small  @click="deleteItem(props.item)">delete</v-icon>
                        </td>
                        <td>{{ props.item.aws_account_id }}</td>
                        <td>{{ props.item.regions.toString() }}</td>
                      </template>
                    </v-data-table>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex flex md12 layout align-top justify-end>
                  <v-btn
                    :disabled="!valid"
                    class="auto"
                    color="success"
                    @click="continueToNextStep('page2')">
                    CONTINUE
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
            <v-form
              ref="form"
            >
              <v-container v-if="(currentPage === 'page2')" class="request-details-p2">
                <v-layout row wrap>
                  <v-flex xs12 sm6 md5>
                    <v-text-field
                      :rules="['Valid WBS Code is required']"
                      v-model="awsAccountValidation.wbsCode"
                      :loading="awsAccountValidation.wbsValidating"
                      :success="awsAccountValidation.wbsCodeValidated"
                      :error="!awsAccountValidation.wbsCodeValidated"
                      :messages="awsAccountValidation.wbsValidationMessage"
                      label="Enter WBS Code"
                      outlined
                      @keypress="onWbsChange"
                    >
                      <template v-slot:append>
                        <v-btn
                          :color="awsAccountValidation.wbsCodeValidated ? 'orange' : ''"
                          class="my-0"
                          small
                          @click="onWbsValidate"
                        >
                          <span
                            v-if="!awsAccountValidation.wbsCodeValidated"
                          >validate</span>
                          <v-icon small v-else>check</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 offset-md1 md6>
                    <v-text-field
                      v-model="awsAccountValidation.wbsType"
                      label="WBS Type"
                      placeholder="WBS Type"
                      messages="WBS Type shows here once WBS code is valid"
                      disabled
                      solo
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md5>
                    <v-text-field
                      v-if="awsAccountValidation.wbsType == 'L-CSC-NonUS WBS'"
                      v-model="awsAccountValidation.iwoCode"
                      :loading="awsAccountValidation.iwoValidating"
                      :success="awsAccountValidation.iwoCodeValidated"
                      :error="!awsAccountValidation.iwoCodeValidated"
                      :messages="awsAccountValidation.iwoValidationMessage"
                      label="Enter IWO Code"
                      @keypress="onIwoChange"
                    >
                      <template v-slot:append>
                        <v-btn
                          :color="awsAccountValidation.iwoCodeValidated ? 'orange' : ''"
                          class="my-0"
                          small
                          @click="onIwoValidate"
                        >
                          <span
                            v-if="!awsAccountValidation.iwoCodeValidated"
                          >validate</span>
                          <v-icon small v-else>check</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex md12>
                    <div
                      v-if="awsAccountValidation.wbsCodeValidated"
                      v-bind:class="{ les: awsAccountValidation.wbsType == 'L-ES WBS' }" 
                      class="acknowledged-section mt-3">
                      <p>NOTE: Please ensure that your WBS code is set up with the correct Major Offering codes </p>
                      <p><b>L-ES WBS Codes</b> should be aligned to <b>service line IDATD 6N or ICSEP 6N</b></p>
                      <div
                        v-if="awsAccountValidation.wbsType == 'L-ES WBS' || awsAccountValidation.wbsType == 'L-CSC-US WBS'"
                        class="wbs-agreement">
                        <p>To validate the major offering code using the following link. The category on the request should be WBS Lookup. <a href='https://dxcportal.sharepoint.com/sites/operationRequest/Lists/OPS%20Requests/Item/newifs.aspx?Source=https%3a//dxcportal.sharepoint.com/sites/operationRequest/SitePages/Home.aspx' target="_blank">https://dxcportal.sharepoint.com/sites/operationRequest/Lists/OPS%20Requests/Item/newifs.aspx?Source=https%3a//dxcportal.sharepoint.com/sites/operationRequest/SitePages/Home.aspx</a></p>
                      </div>
                      <div class="iwo-agreement" v-else>
                        <ul>
                          <li>GSAP WBS Codes should be aligned to Offering Portfolio – O_P1322168</li>
                          <li>C1 WBS Codes should be under C1 Profit Center – P1322168</li>
                          <li>To validate the C1 profit center you can look up your WBS under the here: <a href="https://myfrats.csc.com">https://myfrats.csc.com</a></li>
                        </ul>
                        <br>
                      </div>

                      <p> If your WBS Code is set up under any offering other than AWS Cloud Service (I-AWS) please work with your local finance resource to get a code set up under
                      <b>Major Offering Code I-AWS</b></p>
                      <v-checkbox
                        :disabled="!awsAccountValidation.iwoCodeValidated && awsAccountValidation.wbsType == 'L-CSC-NonUS WBS'"
                        v-model="awsAccountValidation.agreed"
                        light
                        class="mx-2 confirm-validation"
                        color="white"
                        label="I understand and have validated that the major offering code is properly selected."
                      />
                    </div>
                  </v-flex>

                </v-layout>
                <v-layout>
                  <v-flex
                    md6
                    pt-2
                    class="d-flex align-center">
                    <label>Who is the DXC client account team financial owner of the WBS/IWO?</label>
                  </v-flex>
                  <v-flex
                    md6>
                    <v-text-field
                      v-model="newManagedServices.Client_Email_List"
                      label="Email"
                      placeholder="Email"
                      solo
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex
                    md6
                    pt-2
                    class="d-flex align-center">
                    <label>Who is the DXC account contact to receive the Offering Access code after approvals by DXC AWS Practice?</label>
                  </v-flex>
                  <v-flex
                    md6>
                    <v-text-field
                      v-model="newManagedServices.Offering_Access_Email"
                      label="Email"
                      placeholder="Email"
                      solo
                    />
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex
                    md6
                    pt-2
                    class="d-flex align-center">
                    <label>Who is in charge? </label>
                  </v-flex>
                  <v-flex md6 />
                </v-layout>
                <v-layout>
                  <v-flex
                    md6>
                    <v-text-field
                      v-model="newManagedServices.InChargeName"
                      label="Name"
                      placeholder="Name"
                      solo
                    />
                  </v-flex>
                  <v-flex
                    md6>
                    <v-text-field
                      v-model="newManagedServices.InChargeEmail"
                      label="Email"
                      placeholder="Email"
                      solo
                    />
                  </v-flex>
                </v-layout>
                <v-layout align-end>
                  <v-flex flex md12 layout align-top justify-end>
                    <v-btn
                      @click="PreviousPage">
                      PREVIOUS PAGE
                    </v-btn>
                    <v-btn
                      :disabled="!valid"
                      class="auto"
                      color="success"
                      @click="submitData">
                      SUMBIT
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-container v-if="(currentPage === 'submit')" class="request-details-p3">
                <v-layout row wrap>
                  <v-flex class="submitLoading">
                    <v-progress-linear
                      v-if="submitLoading"
                      color="orange"
                      indeterminate/>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </section>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      currentPage: 'page1',
      dialog: false,
      editedItem: {
        aws_account_id: '',
        regions: []
      },
      editedIndex: -1,
      regions: [
        {
          label: 'us-east-1 (N. Virginia)',
          value: 'us-east-1'
        },
        {
          label: 'us-east-2 (Ohio)',
          value: 'us-east-2'
        },
        {
          label: 'us-west-1 (N. California)',
          value: 'us-west-1'
        },
        {
          label: 'us-west-2 (Oregon)',
          value: 'us-west-2'
        },
        {
          label: 'us-gov-west-1 (US GovCloud West)',
          value: 'us-gov-west-1'
        },
        {
          label: 'us-gov-east-1 (US GovCloud East)',
          value: 'us-gove-east-1'
        },
        {
          label: 'ca-central-1 (Canada)',
          value: 'ca-central-1'
        },
        {
          label: 'eu-north-1 (Stockholm)',
          value: 'eu-north-1'
        },
        {
          label: 'eu-west-1 (Ireland)',
          value: 'eu-west-1'
        },
        {
          label: 'eu-west-2 (London)',
          value: 'eu-west-2'
        },
        {
          label: 'eu-west-3 (Paris)',
          value: 'eu-west-3'
        },
        {
          label: 'eu-central-1 (Frankfurt)',
          value: 'eu-central-1'
        },
        {
          label: 'eu-south-1 (Milan)',
          value: 'eu-south-1'
        },
        {
          label: 'af-south-1 (Cape Town)',
          value: 'af-south-1'
        },
        {
          label: 'ap-northeast-1 (Tokyo)',
          value: 'ap-northeast-1'
        },
        {
          label: 'ap-northeast-2 (Seoul)',
          value: 'ap-northeast-2'
        },
        {
          label: 'ap-northeast-3 (Osaka)',
          value: 'ap-northeast-3'
        },
        {
          label: 'ap-southeast-1 (Singapore)',
          value: 'ap-southeast-1'
        },
        {
          label: 'ap-southeast-2 (Sydney)',
          value: 'ap-southeast-2'
        },
        {
          label: 'ap-east-1 (Hong Kong)',
          value: 'ap-east-1'
        },
        {
          label: 'ap-south-1 (Mumbai)',
          value: 'ap-south-1'
        },
        {
          label: 'me-south-1 (Bahrain)',
          value: 'me-south-1'
        },
        {
          label: 'sa-east-1 (São Paulo)',
          value: 'sa-east-1'
        },
        {
          label: 'cn-north-1 (Bejing)',
          value: 'cn-north-1'
        },
        {
          label: 'cn-northwest-1 (Ningxia)',
          value: 'cn-northwest-1'
        },
        {
          label: 'ap-southeast-3 (Jakarta)',
          value: 'ap-southeast-3'
        }
      ],
      headers: [
        {
          text: 'Actions',
          value: 'actions',
          align: 'start',
          sortable: false
        },
        {
          text: 'Client owned AWS Account ID',
          value: 'aws_account_id'
        },
        {
          text: 'Region(s)',
          value: 'regions',
          sortable: false
        }
      ],
      currentList: [
        {
          aws_account_id: '123123',
          regions: ['us-east-1']
        },
        {
          aws_account_id: '456456',
          regions: ['us-east-2']
        },
        {
          aws_account_id: '789789',
          regions: ['us-west-1']
        }
      ],
      data: {
        name: 'John Doe',
        email: 'test@test.com',
        phone: [
          {
            type: 'home',
            number: '123-456-7890'
          },
          {
            type: 'work',
            number: '123-456-7890'
          }
        ],
      },
    }
  },
  computed: {
    ...mapState('user/requestManagedServices', [
      'newManagedServices',
      'managedServicesList',
      'awsAccountList',
      'awsAccountValidation',
      'submitLoading'
    ]),
    searchId: {
      get () {
        return this.newManagedServices.sfdcId
      },
      set (val) {
        console.log('set', val)
        this.setSearchSfdcId(val)
      }
    },
    valid () {
      if (this.currentPage === 'page1') {
        console.log('this.currentList.length > 0', this.currentList.length > 0)
        return (
          this.newManagedServices.Description &&
          this.currentList.length > 0
        )
      } else if (this.currentPage === 'page2') {
        return (
          this.awsAccountValidation.wbsCode &&
          this.awsAccountValidation.wbsCodeValidated &&
          this.newManagedServices.Client_Email_List &&
          this.newManagedServices.Offering_Access_Email
        )
      } else {
        return true
      }
    }
  },
  beforeDestroy () {
  },
  mounted () {
    this.$store.dispatch('user/requestManagedServices/getManagedServices', {})
    this.$store.dispatch('user/requestManagedServices/getAccountList')
  },
  methods: {
    ...mapMutations('user/requestManagedServices', ['setSearchSfdcId']),
    onSearchOpportunityId () {
      this.$store.commit('user/requestManagedServices/setListType', 'workload')
      this.$store.dispatch('user/requestManagedServices/searchOpportunityId', this.searchId)
    },
    onWbsChange () {
      this.newManagedServices.wbsCodeValidated = false
      this.newManagedServices.wbsValidationMessage = ''
    },
    onWbsValidate () {
      this.$store.dispatch("user/requestManagedServices/validateWbsCode",this.awsAccountValidation.wbsCode)
    },
    continueToNextStep (page) {
      this.currentPage = page
    },
    PreviousPage () {
      this.currentPage = 'page1'
    },
    submitData () {
      this.currentPage = 'submit'
      this.searchId = ''
      const selectedOPX_Id = this.managedServicesList.selectedWorkload
      const AWS_Accounts = this.newManagedServices.AWS_Accounts
      const AWS_Regions = this.newManagedServices.AWS_Regions
      const Client_Email_List = this.newManagedServices.Client_Email_List
      const Offering_Access_Email = this.newManagedServices.Offering_Access_Email
      console.log('this.currentList', this.currentList)
      const params = {
        Description: this.newManagedServices.Description,
        AWS_Accounts: AWS_Accounts,
        // AWS_Regions: AWS_Regions.toString(),
        WBS_Code: this.awsAccountValidation.wbsCode,
        WBS_Type: this.awsAccountValidation.wbsType,
        Opportunity_Id: selectedOPX_Id[0].SFDC_Id,
        Client_Email_List: Client_Email_List.toString(),
        Offering_Access_Email: Offering_Access_Email.toString(),
        AccountID: this.newManagedServices.AccountID,
        InChargeName: this.newManagedServices.InChargeName,
        InChargeEmail: this.newManagedServices.InChargeEmail,
        AWS_Account_List:  JSON.stringify(this.currentList),
        Status: 'New'
      }
      this.$store.dispatch('user/requestManagedServices/submitManagedServices', params)
      // this.$store.dispatch('user/requestManagedServices/getManagedServices', {})
    },
    add () {
      let newList = {
        aws_account_id: this.newManagedServices.AWS_Accounts,
        regions: this.newManagedServices.AWS_Regions
      }
      const dataExist = this.currentList.some(item => item.aws_account_id === newList.aws_account_id)
      if (dataExist) {
        alert('Account ID already exists')
      } else {
        console.log('add list')
        this.currentList.push(newList)
        this.newManagedServices.AWS_Accounts = ''
        this.newManagedServices.AWS_Regions = ''
      }
    },
    editItem (item) {
      this.editedIndex = this.currentList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.currentList.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.currentList.splice(index, 1)
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        console.log('save', this.editedIndex)
        Object.assign(this.currentList[this.editedIndex], this.editedItem)
      } else {
        console.log('else save', this.editedIndex)
        this.currentList.push(this.editedItem)
      }
      this.close()
    }
  }
}
</script>
<style lang="scss" >
.userManagedServices {
  // padding: 15px 0;
  background-color: #fff;
  height:100%;

  .header {
    .opportunity-lookup {
      padding: 10px;
      background: #000;
      color: #fff;
    }

    .opportunity-details {
      background: #000;
      color: #fff;
      padding: 10px 10px 20px 10px;

      [type=text] {
        color: #fff;
      }
    }
    .search-opp {
      background-color: #000;
      margin: 15px 15px;
      padding: 25px 15px;
      .v-messages {
        min-height: 0 !important;
      }
      .v-text-field.v-text-field--enclosed .v-text-field__details {
        margin-bottom: 0;
      }
    }

    .v-text-field__slot .v-label {
      color: #fff !important;
    }
  }
}

.view-link {
  cursor: pointer;
  color: #ff9900 !important;
}
table.v-table thead th {
  font-weight: 600;
}

section.userAwsAccount {
  .search-opp {
    background-color:#000;
    margin:15px 15px;
    padding:25px 15px
  }
  table.v-table thead th {
    font-weight: 600;
  }

  .v-datatable thead th {
    // background-color: #000;
    // color: #fff;
    font-weight: 400;

    span {
      // color: #fff !important;
      font-size: 14px !important;
      font-weight: 500 !important;
    }
  }
}
.request-details {
  border-top: 1px solid lightgray;
  margin: 25px;
  padding: 0px 0px 25px 0px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 3px;

  .form-row {
    margin-bottom: 20px;
  }
}
.section-header {
  margin: 0px 0px 25px 0px;
  padding: 0px;
}
.section-header-title {
  background-color:#000;
  color: #fff;
  padding:0 15px
}
.acknowledged-section {
  padding: 20px;
  background: #ff9900;
  margin-bottom: 20px;

  &.les {
    background: yellow;
  }

  a {
    color: #000;
    text-decoration: underline;
  }
}

.confirm-validation {
  label {
    color: #000 !important;
    font-weight: 500 !important;
  }
}
.submitLoading {
  padding: 50px 0px;
}
</style>
